import { copyToClipboard, shortenHash } from '@/utils';
import { Copy } from 'lucide-react';
import React from 'react';
import { Tooltip } from 'react-tooltip';

interface TooltipTruncateProps {
  text: string | undefined;
  maxLength?: number;
  id: string; // Unique tooltip id (required by react-tooltip)
  className?: string;
  copybtn?: boolean;
}

const TooltipTruncate: React.FC<TooltipTruncateProps> = ({
  text,
  maxLength = 40,
  id,
  className,
  copybtn = false,
}) => {
  const isTruncated = text && text.length > maxLength;
  const displayText = isTruncated ? shortenHash(text) : text;

  return (
    <div className="flex items-center gap-2">
      <span
        data-tooltip-id={id}
        data-tooltip-content={text}
        className={`cursor-pointer ${className}`}
      >
        {displayText}
      </span>

      {isTruncated && (
        <Tooltip
          id={id}
          place="top"
          style={{
            background: '#333',
            color: '#fff',
            padding: '6px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            maxWidth: '300px',
          }}
        />
      )}
      {copybtn && (
        <Copy size={16} className="cursor-pointer" onClick={() => text && copyToClipboard(text)} />
      )}
    </div>
  );
};

export default TooltipTruncate;
